import { Component } from '@angular/core';
import { UserService } from '../../providers/session-service/user-service';
import { MenuController, NavController, Platform } from "ionic-angular";
import { PostsPage } from "../posts/posts";
import { MapPage } from "../map/map";
import { SettingsPage } from "../settings/settings";
import { TeamPage } from "../team/team";
import { TeamShowcasePage } from "../team-showcase/team-showcase";
import { GalleryPage } from "../gallery/gallery";
import { AngularFirestore } from 'angularfire2/firestore';

@Component({
    selector: 'page-home',
    templateUrl: 'home.html'
})
export class HomePage {

    userData: any;
    sessionType: string;
    sponsors: any;
    liveMatch: any;
    tiles: Array<{ image: string, title: string, component: Object }>;

    constructor(public platform: Platform, public userService: UserService, private menu: MenuController,
        public navCtrl: NavController, public db: AngularFirestore) {
        this.menu = menu;
        this.menu.enable(true);
        this.sessionType = userService.getSessionType();
        this.tiles = [];
        this.sponsors = [];
        this.platform = platform;
    }


    ionViewDidLoad() {
        if (this.sessionType === "player") {
            this.tiles.push(
                {
                    image: '',
                    title: 'Η ομάδα μου',
                    component: TeamPage
                }
            )
        } else {
            this.tiles.push(
                {
                    image: 'assets/img/teams.jpg',
                    title: 'Όλες οι ομάδες',
                    component: TeamShowcasePage
                }
            )
        }
        this.tiles.push(
            {
                image: 'assets/img/news.jpg',
                title: 'Ανακοινώσεις',
                component: PostsPage
            },
            {
                image: 'assets/img/gallery.jpg',
                title: 'Gallery',
                component: GalleryPage
            },
            {
                image: 'assets/img/map.jpg',
                title: 'Πού θα μας βρείτε',
                component: MapPage
            }
        );


        if (this.sessionType !== "guest") {
            this.loadUser();
        }

        this.loadSponsors();
        this.loadLiveMatch();
    }

    loadLiveMatch() {
        this.db.doc("other/live match").valueChanges().subscribe(liveMatch => {
            this.liveMatch = liveMatch;
        });
    }

    loadSponsors() {
        this.db.doc('other/sponsors').valueChanges().subscribe(sponsors => {
            this.sponsors = sponsors['banners'];
        });
    }

    loadUser() {
        this.userData = this.userService.getUser();

        this.db.doc("teams/" + this.userData.teamId).valueChanges().subscribe(team => {
            this.userData.team = team;
            if (this.sessionType === "player") this.tiles[0].image = team['photo'];
        });
    }

    switchTo(tile: any) {
        if (tile.component === TeamPage) {
            this.navCtrl.push(TeamPage, {
                'team': this.userData.team
            })
        } else {
            this.navCtrl.push(tile.component);
        }
    }

    switchToSettings() {
        this.navCtrl.push(SettingsPage);
    }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts